import type { LandingComponents } from "@/puck/blocks/blockTypes";
import { ChartMockupBlock } from "@/puck/landing/chartMockupBlock";

export const chartMockupConfigs: Pick<LandingComponents, "ChartMockup"> = {
  ChartMockup: {
    label: "Chart mockup",
    fields: {
      rows: {
        type: "array",
        label: "Bar rows",
        getItemSummary: (item) => `${item.label}: ${item.value}`,
        defaultItemProps: {
          label: "Category",
          value: 100,
        },
        arrayFields: {
          label: { type: "text", contentEditable: true },
          value: { type: "number", label: "Value" },
        },
      },
      footnote: { type: "textarea", contentEditable: true },
      showTrendArrow: {
        type: "radio",
        label: "Trend arrow",
        options: [
          { label: "Show", value: true },
          { label: "Hide", value: false },
        ],
      },
    },
    defaultProps: {
      rows: [
        { label: "Pricing", value: 412 },
        { label: "Coverage", value: 287 },
        { label: "Payment", value: 154 },
        { label: "Claims status", value: 98 },
      ],
      footnote:
        "Pricing inquiries up 23% QoQ — most common topic across your book.",
      showTrendArrow: true,
    },
    render: ChartMockupBlock,
  },
};
